import WeGlide from 'client/javascript/we_glide/we_glide';
import { settings as raySettings } from '@wework/ray-core';

const PLAY_BUTTON_SELECTOR = '.slider__play-btn';
const PLAY_ANIMATION_OPTIONS = ['animationDuration', 'rewindDuration'];
const PLAY_BUTTON_STATES = {
  PLAY: 'play',
  PAUSE: 'pause'
};
const DEFAULT_GLIDE_OPTIONS = {
  hoverpause: false,
  autoplay: false
};

function isPhoneBreakpoint() {
  return window.innerWidth < raySettings.breakpointsInPixels.tablet;
}

export default class WeGlideWithAutoplay {
  constructor(sliderSelector, options = {}) {
    this.isActive = false;
    this.autoplay = false;
    this.delay = 0;
    this.timer = false;
    this.glideOptions = {
      ...DEFAULT_GLIDE_OPTIONS,
      ...options
    };
    this.sliderElement = document.querySelector(sliderSelector);

    if (this.sliderElement) {
      this.handleAutoplayClick = this.handleAutoplayClick.bind(this);
      this.pause = this.pause.bind(this);
      this.initAutoplay();
      this.mainWeGlide = new WeGlide(sliderSelector, this.glideOptions);
      this.initRewind();

      if (this.autoplay && !this.timer) {
        this.play();
      }
    }
  }

  get glideInstance() {
    return this.mainWeGlide.glide;
  }

  initAutoplay() {
    const { autoplay, autoplayDelay } = this.sliderElement.dataset;

    if (!isPhoneBreakpoint() && autoplay) {
      this.autoplay = Number(autoplay) || false;
      this.delay = Number(autoplayDelay) || 0;
      if (this.autoplay) {
        this.applyAutoplay();
      }
    }
  }

  applyAutoplay() {
    this.autoplayBtn = this.sliderElement.querySelector(PLAY_BUTTON_SELECTOR);

    if (this.autoplayBtn) {
      this.autoplayBtn.addEventListener('click', this.handleAutoplayClick);
    }

    this.initAnimationOptions();
    this.initDelayBeforeStart();
  }

  initAnimationOptions() {
    PLAY_ANIMATION_OPTIONS.forEach((option) => {
      const value = this.sliderElement.dataset[option];
      if (value && Number(value)) {
        this.glideOptions[option] = Number(value);
      }
    });
  }

  initDelayBeforeStart() {
    if (this.delay) {
      this.glideOptions.autoplay = false;
      this.timer = setTimeout(() => {
        this.timer = false;
        if (!this.isActive) {
          this.mainWeGlide.goToNext();
          this.play();
        }
      }, this.delay);
    }
  }

  setAutoplayState(state) {
    this.isActive = state === PLAY_BUTTON_STATES.PAUSE;
    this.autoplayBtn.setAttribute('data-autoplay-state', state);
  }

  handleAutoplayClick() {
    if (this.timer) {
      clearTimeout(this.timer);
    }

    if (this.isActive) {
      this.pause();
    } else {
      this.play();
    }
  }

  initRewind() {
    if (this.autoplay) {
      this.glideInstance.on('run.start', this.pause);
    }
  }

  play() {
    this.glideInstance.update({ autoplay: Number(this.autoplay) });
    this.setAutoplayState(PLAY_BUTTON_STATES.PAUSE);
  }

  pause() {
    this.glideInstance.update({ autoplay: false });
    this.setAutoplayState(PLAY_BUTTON_STATES.PLAY);
  }

  mount() {
    this.glideInstance.mount();
  }
}
